import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  CardTitle, CardSubtitle,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap"
import { Link } from "react-router-dom"
import { get, post } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import Select from "react-select"
import moment from 'moment'
import { connect } from "react-redux"

import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';

import cogoToast from 'cogo-toast';

const AlertLog = props => {
  const [servicetypes, setServicetypes] = React.useState([]);

  const [serviceType, setServiceType] = useState(null);
  const [startDate, setStartDate] = React.useState(moment().subtract(1, 'week').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = React.useState(moment().format('YYYY-MM-DD'));
  const [open, setOpen] = useState(true);
  const [closed, setClosed] = useState(false);

  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState([]);
  const [errors, setErrors] = React.useState([]);


  const columns = [{
    dataField: 'slno',
    text: '#',
  },
  {
    dataField: 'scheduled_date',
    text: 'Scheduled Date',
  }, 
  {
    dataField: 'created_at',
    text: 'Completed at',
    formatter: (cell, row)=> moment(cell.created_at).format('DD MMM YYYY hh:mm a')
  }, 
  {
    dataField: 'asset_name',
    // formatter: ()=>'-'
  }, 
  {
    dataField: 'activity_name',
    text: 'Activity Name',
  }, 
  {
    dataField: 'user.name',
    text: 'Done by',
  }, 
  {
    dataField: 'groupnames',
    text: 'Groups',
    formatter: (cell) => JSON.parse(cell) ? JSON.parse(cell).join(', ') : '-'
  }, 
  {
    dataField: 'status',
    text: 'Status',
  }, 
  {
    text: 'Alert Comment',
    formatter: ()=>'-'
  }, 
  {
    text: 'Remark',
    formatter: ()=>'-'
  }, 
  {
    dataField: 'parameter',
    text: 'Parameter',
  }, 
  {
    dataField: 'reading',
    text: 'Reading',
  }, 
  {
    dataField: 'unit_of_measure',
    text: 'UOM',
  }, 
  {
    dataField: 'warning_min',
    text: 'Warning Min',
  }, 
  {
    dataField: 'warning_max',
    text: 'Warning Max',
  }, 
  {
    dataField: 'field_min',
    text: 'Field Min',
  }, 
  {
    dataField: 'field_max',
    text: 'Field Max',
  }, 
  {
    text: 'Level',
    formatter: ()=>'-'
  }, 
  // {
  //   dataField: 'activity_code',
  //   text: 'Activity Code',
  //   sort: true,
  //   filter: textFilter(),
  // }, {
  // text: 'Form Name',
  //   dataField: 'form.name',
  // sort: true,
  // filter: textFilter(),
  // }, {
  //   text: 'Activity Name',
  //   dataField: 'name',
  //   sort: true,
  //   filter: textFilter(),
  //   }, 
  // {
  //   text: 'Activity Type',
  //   dataField: 'activity_type',
  //   sort: true,
  //   filter: textFilter(),
  // }, {
  //   text: 'Assets',
  //   dataField: 'assets.length',
  //   sort: true,
  //   filter: textFilter(),
  // }, {
  //   text: 'Frequency',
  //   dataField: 'frequency.type',
  //   sort: true,
  //   filter: textFilter(),
  // }, 
  // {
  //   text: 'Actions',
  //   formatter: (cell, row, rowIndex)=> {
  //     return <div className="d-flex">
  //       <Button color="link" title="View details" onClick={()=>{
  //       console.log('Edit : '+row.id);
  //       }}>
  //         <i className="bx bx-info-circle" style={{color: '#667CE8', fontSize: 19,}}></i></Button>{' '}
  //         <Link className="btn btn-secondary" to={{pathname: "/activities/new", query: row}}>Edit</Link>{' '}
  //       <Button color="link" title="Delete" onClick={()=>{
  //       console.log('Edit : '+row.id);
  //       }}><i className="bx bx-trash" style={{color: '#667CE8', fontSize: 19,}}></i></Button>
  //     </div>;
  //   }
  // },
  ];


  const init = () => {

    let initData = {
      property_id: props.filterProperty.id,
      block_id: props.filterBlock.id,
    };

    setLoading(true);
    post(url.INIT_ALERTLOG, initData)
      .then((response) => {
        console.log('init RESP', response);
        if (response.status == 200) {
        setServicetypes(response.data.servicetypes);
        // setGroups(response.data.groups);
        }
        else if (response.status == 400) {
          cogoToast.error('Could not fetch data');
        }
        else {
          console.log('err::', response);
          cogoToast.error('Could not fetch data');
        }
        setLoading(false);
      }, (error) => {
        console.log(error);
        setLoading(false);
      });

  };

  const handleSubmit = () => {

    if((serviceType == undefined) 
      // || (startDate == undefined) || (endDate == undefined) || 
      // (!open && !closed)
      ) 
      {
      cogoToast.error('Please fill all the required fields');
      return;
    }

    let data = {
      'servicetype_id': serviceType,
      'from': startDate,
      'to': endDate,
      'open': open,
      'closed': closed,
      'block_id': props.filterBlock.id,
    };

    console.log('data', data);

    setLoading(true);
    setErrors([]);

    post(url.POST_ALERTLOG, data)
    .then((response) => {
      console.log('RESP', response);
      if(response.status == 200) {
        setData(response.data)
      }
      else if(response.status == 400) {
        setErrors(Object.values(response.error));
      }
      else {
        console.log('err::', response);
      }
    }, (error) => {
      console.log(error);
      setLoading(false);
    });

  };


React.useEffect(()=>{
    if(props.filterBlock) {
      // setSelectedServicetypes([]);
      init();
    }
  }, [props.filterBlock]);

  // console.log(open, closed)

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Alert Log | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">Alert Log</h3>
            {/* <Link className="btn btn-primary" to={{pathname: "/activities/new", query: {id: 'new'}}}>Create New</Link> */}
          </div>

          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">Forms</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="row">
                <div className="col">
                  <div className="">
                    <label className="label form-label">Service Type</label>
                    <Select
                        classNamePrefix="select2-selection"
                        placeholder="Select one..."
                        title="Service type"
                        options={servicetypes}
                        value={serviceType}
                        onChange={e => { 
                            setServiceType(e); 
                        }}
                        />
                  </div>
                </div>
                <div className="col">
                  <div className="">
                    <label className="label form-label">From</label>
                    <input type="text" className="form-control" id="dateFrom"
                      type="date"
                      value={startDate} onChange={e => { setStartDate(e.target.value); }}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="">
                    <label className="label form-label">To</label>
                    <input type="text" className="form-control" id="dateFrom"
                      type="date"
                      value={endDate} onChange={e => { setEndDate(e.target.value); }}
                    />
                  </div>
                </div>
                {/* <div className="col">
                  <div className="d-flex flex-column justify-content-center align-items-start ps-3 text-left">
                    <label className="label form-label">Status</label>
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" value={open} onChange={e=>{
                          setOpen(!open);
                        }} id="flexCheckDefault" />
                      <label className="form-check-label" htmlFor="flexCheckDefault">
                        Open
                      </label>
                    </div>
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" value={closed} onChange={e=>{
                          setClosed(!closed);
                        }}  id="flexCheckChecked" />
                      <label className="form-check-label" htmlFor="flexCheckChecked">
                        Closed
                      </label>
                    </div>
                  </div>
                </div> */}
              </div>

              <div className="d-flex justify-content-center mt-4">
                <button type="button" className="btn btn-primary" onClick={() => { handleSubmit(); }}>Generate</button>
              </div>
            </CardBody>
          </Card>



          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">Forms</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <BootstrapTable striped
                bordered={false}
                wrapperClasses="table-responsive" className="border border-danger" keyField='id' data={ data } columns={ columns } filter={ filterFactory() } pagination={ paginationFactory() } />
            </CardBody>
          </Card>

        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(AlertLog)